<template>
  <div class="container">
    <h1>Experience Center</h1>
    <p class="text-justify">
      Additionally, it is possible to expend your stand with an experience center.
      In this way students can get to know your company in a more interactive way.
      Since it is yet undefined, we are open to all ideas. Click
      <a
        href
        @click.prevent="showModal = true"
      >here</a>
      for examples.
      If you want to make use of this option, we will ask you to send your concept idea no later than
      <span
        class="font-weight-bold"
      >30th of September 2019</span>
      to
      <a href="mailto:acquisition@wervingsdagen.nl">acquisition@wervingsdagen.nl</a>.
      When there are more companies interested in the Experience Center we will have to make a selection.
      Then we will look at the interactive character of the object.
    </p>
    <p>Would you like to participate in the Experience Center?</p>
    <YesNo v-model="subscriberData.ExperienceCenter" name="experience" />
    <router-link to="/subscribe/package-selection">
      <button class="btn btn-secondary">Back</button>
    </router-link>
    <router-link
      to="/subscribe/speed-dates"
      v-if="$store.getters.getOption('speed-dates')"
    >
      <button class="btn btn-primary">Next</button>
    </router-link>
    <router-link to="/subscribe/career-expo-options" v-else>
      <button class="btn btn-primary">Next</button>
    </router-link>
    <OptionModal v-if="showModal" v-on:close="showModal = false" :option="$store.getters.events['career-expo'].options['experience-center']"/>
  </div>
</template>

<script>
import OptionModal from "@/components/OptionModal.vue";
import YesNo from "@/components/YesNo.vue";

export default {
  name: "experience-center",
  components: {
    OptionModal,
    YesNo
  },
  computed: {
    subscriberData() {
      return this.$store.state.subscriberData;
    }
  },
  data() {
    return {
      showModal: false
    };
  }
};
</script>